<template>
    <div class="section-city" :class="background">
        <div class="container">
            <div class="row justify-content-center">
                <div class="title">
                    <h2 class="h1 p-title p-black p-center mb-0 relawayBold">Cities</h2>
                </div>
            </div>
            <div class="city-row">
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
                <div class="city-item">
                    <a href="#">Jonkoping</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "cityPart",
        props: ['background'],
    }
</script>

